export default __webpack_public_path__ + "static/media/programs-stress.75f6a514.png";